import {
  LOAD_BALANCE,
  LOAD_PAIRS,
  LOAD_NDWALLET_ORDER_HISTORY,
} from 'redux/actions/NDWalletData';

const initialState = {
  balance: [],
  isBalanceLoading: false,
  tradingPairs: [],
  isPairsLoading: false,
  ndWalletOrderHistoryLoad: false,
};

export const NDWalletReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_BALANCE.STARTED:
      return { ...state, isBalanceLoading: true };
    case LOAD_BALANCE.SUCCESS:
      return {
        ...state,
        isBalanceLoading: false,
        balance: action.payload,
      };
    case LOAD_BALANCE.FAIL:
      return {
        ...state,
        isBalanceLoading: false,
      };

    // ------------- PAIRS -------------

    case LOAD_PAIRS.STARTED:
      return { ...state, isPairsLoading: true };
    case LOAD_PAIRS.SUCCESS:
      return {
        ...state,
        isPairsLoading: false,
        tradingPairs: action.payload,
      };
    case LOAD_PAIRS.FAIL:
      return {
        ...state,
        isPairsLoading: false,
      };

    case LOAD_NDWALLET_ORDER_HISTORY:
      return {
        ...state,
        ndWalletOrderHistoryLoad: action.payload,
      };

    default:
      return state;
  }
};
